<template>
  <div class="matchmaking-widget-container">
    <div class="row">
      <div
        class="col-md-4"
        v-if="sudesteCount"
        v-b-tooltip.hover
        title="jogadores buscando ranked geral agora"
      >
        <div class="mm-players-box">
          <h6>brasil</h6>
          <span>{{sudesteCount}}</span>
          buscando
        </div>
      </div>
      <div
        class="col-md-4"
        v-if="nordesteCount"
        v-b-tooltip.hover
        title="jogadores buscando ranked no club Jogadores Nordeste agora"
      >
        <div class="mm-players-box">
          <h6>nordeste</h6>
          <span>{{nordesteCount}}</span>
          buscando
        </div>
      </div>
      <div
        class="col-md-4"
        v-if="girlsCount"
        v-b-tooltip.hover
        title="jogadores buscando ranked no club Girl Power"
      >
        <div class="mm-players-box">
          <h6>girl power</h6>
          <span>{{girlsCount}}</span>
          buscando
        </div>
      </div>
      <div
        class="col-md-4"
        v-if="depreCount"
        v-b-tooltip.hover
        title="jogadores buscando ranked no club CSGO da Deprê"
      >
        <div class="mm-players-box">
          <h6>@depre</h6>
          <span>{{depreCount}}</span>
          buscando
        </div>
      </div>
    </div>
    <h4>
      {{club_name}}
      <div v-if="playersCount"></div>
      <div v-else></div>
    </h4>
  </div>
</template>

<script>
export default {
  name: "MatchmakingWidget",
  props: {
    club_id: String,
    club_name: String
  },
  data() {
    return {
      playersCount: 0,
      sudesteCount: 0,
      nordesteCount: 0,
      girlsCount: 0,
      depreCount: 0,
      interval: null
    };
  },
  methods: {
    initialize() {
      this.$http.get(`matchmaking_players.json`).then(response => {
        this.playersCount = response.data.length;
        this.sudesteCount = response.data.filter(mm => !mm.club_id).length;
        this.nordesteCount = response.data.filter(
          mm => mm.club_id == "ad1c7034-fcaa-4d87-b1d7-433d55d2390b"
        ).length;
        this.girlsCount = response.data.filter(
          mm => mm.club_id == "e3ca335a-af6e-4044-9f07-f8e880744fd4"
        ).length;
        this.depreCount = response.data.filter(
          mm => mm.club_id == "3f9925b6-e157-4d62-9490-e6886ad2afa0"
        ).length;
      });
    }
  },
  mounted() {
    this.initialize();
    this.interval = setInterval(() => {
      this.initialize();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="sass" scoped>
.matchmaking-widget-container
  margin-top: 10px
  h4
    font-size: 13px
    text-align: center
  .mm-players-box
    background: rgba(0, 0, 0, .1)
    border-radius: 4px
    font-size: 12px
    padding: 10px
    h6
      margin: 0
      font-weight: normal
    span
      display: block
      // color: rgba(255, 255, 255, .4)
      font-family: 'Oswald', monospace
      font-size: 18px
</style>
